import { GenderType, MinorPickUp } from '@/api';

import { ACCESSIBILITY } from './enums';

export const MINOR_PICK_UP_OPTIONS = [
  {
    label: 'Yes, minor can leave the test unaccompanied',
    value: MinorPickUp.Itself,
  },
  {
    label: 'No, minor will be collected by the legal guardian',
    value: MinorPickUp.Parent,
  },
  {
    label: 'No, minor will be collected by the specified adult',
    value: MinorPickUp.Guardian,
  },
];

export const GENDER_OPTIONS = [
  { value: GenderType.Female, label: 'Female' },
  { value: GenderType.Male, label: 'Male' },
  { value: GenderType.Other, label: 'Other' },
];

export const TEST_TAKING_REASON_OTHER = 5;

export const ACCESSIBILITY_OPTIONS = [
  { value: ACCESSIBILITY.NO, label: 'No' },
  { value: ACCESSIBILITY.YES, label: 'Yes' },
];
